<template>
  <div class="columns form-wrapper">
    <loader :loading="loading" :fixed="false"></loader>
    <form class="column is-8">
      <switch-button :label="$resx('Header.UseTheme')" v-model="staticHeader.UseTheme"></switch-button>
      <div class="fieldset" :disabled="staticHeader.UseTheme">
        <file-input v-if="staticHeader.Image || staticHeader.Image === ''" :value.sync="staticHeader.Image" @complete="setImage" :disabledProfiles="['meta', 'inline', 'fullwidth', 'image', 'icon', 'avatar', 'partner', 'theme']"></file-input>
        <div class="field">
          <label class="label">{{ $resx("Header.Title") }}</label>
          <div class="control">
            <input class="input" type="text" v-model="staticHeader.Title" />
          </div>
        </div>
        <div class="field">
          <label class="label">{{ $resx("Header.Subtitle") }}</label>
          <div class="control">
            <input class="input" type="text" v-model="staticHeader.Subtitle" />
          </div>
        </div>
        <div class="field">
          <label class="label">{{ $resx("Header.Link") }}</label>
          <div class="control has-icons-right">
            <input class="input" type="text" v-model="staticHeader.CallToAction.Link" />
            <page-select @input="staticHeader.CallToAction.Link = $event"></page-select>
          </div>
        </div>
        <div class="field">
          <label class="label">{{ $resx("Header.Button") }}</label>
          <div class="control">
            <input class="input" type="text" v-model="staticHeader.CallToAction.Text" />
          </div>
        </div>
        <div class="field">
          <label class="label">{{ $resx("Align.Title") }}</label>
          <div class="control">
            <div class="field has-addons">
              <p class="control" v-for="(item, idx) in align" :key="idx">
                <button class="button" :class="{'is-success': staticHeader.Align === item }" @click.prevent="staticHeader.Align = item">
                  <span>{{ $resx("Align." + item) }}</span>
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="column is-4">
      <div class="buttons">
        <button class="button is-fullwidth is-success" @click.prevent="submitHeader('submit')" :disabled="(submitEnabled ? false : 'disabled')">
          <span>{{ $resx("Buttons.Save") }}</span>
        </button>
        <button class="button is-fullwidth" @click.prevent="submitHeader('cancel')">
          <span>{{ $resx("Buttons.Cancel") }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import fileInput from '@/components/admin/FileInput.vue'
import { faToggleOn, faToggleOff, faPlus, faPencil, faTimes } from '@fortawesome/pro-regular-svg-icons'
import { getFilenameFromUrl } from '@/mixins/getFilenameFromUrl.js'
import pageSelect from '@/components/admin/Pageselect.vue'
import switchButton from '@/components/admin/Switch.vue'
import loader from '@/components/Loader.vue'

export default {
  name: 'modalContentHeader',
  data () {
    return {
      loading: false,
      icons: {
        toggleOn: faToggleOn,
        toggleOff: faToggleOff,
        add: faPlus,
        edit: faPencil,
        delete: faTimes
      },
      staticHeader: {
        CallToAction: {}
      },
      callBeforeDestroy: true,
      align: ['Left', 'Center', 'Right']
    }
  },
  mixins: [getFilenameFromUrl],
  components: {
    fileInput,
    pageSelect,
    switchButton,
    loader
  },
  computed: {
    submitEnabled () {
      return !(JSON.stringify(this.staticHeader) === JSON.stringify(this.header))
    },
    header () {
      return this.activePage.Cultures[this.$store.state.language].Header
    },
    activePage () {
      return this.$store.state.activePage
    }
  },
  mounted () {
    this.staticHeader = JSON.parse(JSON.stringify(this.header))
    this.callBeforeDestroy = true
    this.$store.commit('contentChanged', true)
  },
  beforeDestroy () {
    var self = this
    self.$store.commit('contentChanged', false)
    if (self.callBeforeDestroy) {
      self.deleteImage(true)
    }
  },
  methods: {
    deleteImage: function (canceled) {
      var self = this; var newObj; var oldObj
      if (canceled) {
        oldObj = self.staticHeader
        newObj = self.header
      } else {
        oldObj = self.header
        newObj = self.staticHeader
      }

      if (oldObj && oldObj.Image && newObj && self.submitEnabled && oldObj.Image !== '' && newObj.Image !== oldObj.Image) {
        var file = self.getFilenameFromUrl(oldObj.Image)
        self.$store.dispatch('deleteFile', file)
      }
    },
    submitHeader: function (action) {
      var self = this
      if (action === 'submit') {
        // save header
        self.loading = true
        self.$http({
          method: 'PUT',
          url: '/pages/header/' + self.activePage.ID,
          api: 'website',
          data: self.staticHeader,
          name: process.env.VUE_APP_NAME + '_' + self.$store.state.language
        }).then(function (response) {
          self.deleteImage(false)
          self.$store.dispatch('changeHeader', response.data)
          self.loading = false
          self.staticHeader = { CallToAction: {} }
          self.callBeforeDestroy = false
          self.$emit('close')
          self.$store.dispatch('setSnack', {
            message: self.$resx('Header.Saved')
          })
        }).catch(function (err) {
          self.loading = false
          self.staticHeader = { CallToAction: {} }
          self.callBeforeDestroy = false
          self.$emit('close')
          self.$store.dispatch('setSnack', {
            message: err.message
          })
        })
      } else {
        self.callBeforeDestroy = false
        self.deleteImage(true)
        self.$emit('close')
        self.staticHeader = { CallToAction: {} }
      }
    },
    setImage: function (data) {
      var self = this
      self.staticHeader.Image = data.url
    }
  }
}
</script>

<style lang="scss" scoped>

.edit-fade-enter-active,
.edit-fade-leave-active {
  transition: opacity 0.2s;
}
.edit-fade-enter,
.edit-fade-leave-to{
  opacity: 0;
}
.flip-list-move {
  transition: transform 0.5s;
}
.ghost {
  opacity: 0.3;
}

.form-wrapper{
  >.is-8{
    height: 450px;
    overflow: auto;

    .fieldset[disabled] {
      /deep/ .input, /deep/.input-div, /deep/.button{
        background-color: $grey-lightest;
        border-color: $grey-lightest;
        box-shadow: none;
        color: $grey-light;
        cursor: not-allowed;
      }
      /deep/ .control, /deep/.icon{
        pointer-events: none;
      }
    }
  }
}
</style>
